/** @file Events panel registration: event list, default payloads and keys at the playhead. */
import { rigPanel } from '../rigKit/rigPanel';
import { EventsView } from './EventsView';

/** Rig panel over event.* and animation.setEventKey / deleteKeys. */
export const panel = rigPanel('events', 'panels.events.title', EventsView);
